import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import LanguageToggle from './LanguageToggle';
import { useTranslation } from '../hooks/useTranslation';

const { FiShield, FiMenu, FiX } = FiIcons;

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const { t } = useTranslation();

  const handleGetQuote = () => {
    window.open('https://quote.burbankinsuranceservices.com/1b0DiB', '_blank');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-4">
            <img
              src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
              alt="Burbank Insurance Services"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/term-vs-whole-life"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              {t('header.termVsWhole')}
            </Link>
            <Link
              to="/online-vs-agent"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              {t('header.onlineVsAgent')}
            </Link>

            <div className="flex items-center space-x-6">
              <SafeIcon icon={FiShield} className="text-blue-600 text-xl" />
              <div className="text-right">
                <span className="text-sm font-medium text-gray-700 block">
                  {t('header.licensedInCalifornia')}
                </span>
                <span className="text-xs text-gray-500">
                  {t('header.licenseNumber')}
                </span>
              </div>
            </div>

            {/* Language Toggle */}
            <LanguageToggle />

            <button
              onClick={handleGetQuote}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors duration-200"
            >
              {t('header.getMyPrice')}
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-4">
            <LanguageToggle />
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-700"
            >
              <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/term-vs-whole-life"
                className="text-gray-700 hover:text-blue-600 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('header.termVsWhole')}
              </Link>
              <Link
                to="/online-vs-agent"
                className="text-gray-700 hover:text-blue-600 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('header.onlineVsAgent')}
              </Link>
              
              <div className="flex items-center space-x-3 py-2">
                <SafeIcon icon={FiShield} className="text-blue-600 text-lg" />
                <div>
                  <span className="text-sm font-medium text-gray-700 block">
                    {t('header.licensedInCalifornia')}
                  </span>
                  <span className="text-xs text-gray-500">
                    {t('header.licenseNumber')}
                  </span>
                </div>
              </div>
              
              <button
                onClick={handleGetQuote}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 text-center"
              >
                {t('header.getMyPrice')}
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;